/**
 * Token Storage Utility
 * Auto-generated - Auth Tokens Infrastructure Component
 *
 * Persists tokens in localStorage so the session survives page reloads and
 * external redirects (e.g. Stripe checkout). XSS exposure is accepted as the
 * standard SPA trade-off; AuthProvider is the only consumer and no page
 * component may read these keys directly.
 */

const ACCESS_TOKEN_KEY = "auth.accessToken";
const REFRESH_TOKEN_KEY = "auth.refreshToken";

function readItem(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeItem(key: string, value: string | null): void {
  try {
    if (value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch {
    // localStorage disabled (private mode etc) — fall back silently.
  }
}

export const tokenStorage = {
  getAccessToken(): string | null {
    return readItem(ACCESS_TOKEN_KEY);
  },

  setAccessToken(token: string | null): void {
    writeItem(ACCESS_TOKEN_KEY, token);
  },

  getRefreshToken(): string | null {
    return readItem(REFRESH_TOKEN_KEY);
  },

  setRefreshToken(token: string | null): void {
    writeItem(REFRESH_TOKEN_KEY, token);
  },

  setTokens(access: string, refresh: string): void {
    writeItem(ACCESS_TOKEN_KEY, access);
    writeItem(REFRESH_TOKEN_KEY, refresh);
  },

  clearTokens(): void {
    writeItem(ACCESS_TOKEN_KEY, null);
    writeItem(REFRESH_TOKEN_KEY, null);
  },

  hasTokens(): boolean {
    return readItem(ACCESS_TOKEN_KEY) !== null && readItem(REFRESH_TOKEN_KEY) !== null;
  },
};
